import { render, staticRenderFns } from "./CheckInfoTab.vue?vue&type=template&id=280799df&scoped=true&"
import script from "./CheckInfoTab.vue?vue&type=script&lang=js&"
export * from "./CheckInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./CheckInfoTab.vue?vue&type=style&index=0&id=280799df&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280799df",
  null
  
)

export default component.exports